<template>
	<el-breadcrumb v-if="showBreadcrumbs" separator-class="el-icon-arrow-right">
		<el-tooltip
			v-for="(name, index) in history"
			:key="index"
			:content="pathUpTo(index)"
			placement="top"
			:open-delay="2000"
		>
			<el-breadcrumb-item :to="{ path: pathUpTo(index) }">
				{{ showName(name, index) }}
			</el-breadcrumb-item>
		</el-tooltip>
	</el-breadcrumb>
</template>

<script>
import axios from "axios"

export default {
	name: "app-breadcrumb",
	props: ["history"],
	data: () => ({
		names: [],
		breadcrumbs: []
	}),
	computed: {
		showBreadcrumbs() {
			return this.names.length || this.$route.name.split(".").length > 1
		}
	},
	created() {
		this.setRoute()
	},
	watch: {
		$route: function() {
			this.setRoute()
		}
	},
	methods: {
		setRoute() {
			let route = this.$route.name
			for (const [key, value] of Object.entries(this.$route.params)) {
				route = route.replace(key, value)
			}
			route = route.split(".")

			if (route.length === 1) route = []
			this.$emit("mutate", { element: "breadcrumb", value: route })

			this.breadcrumbs = route

			this.getNames()
		},
		getNames() {
			const skips = ["payment"]
			const routeNames = this.$route.name.split(".")

			const apiCalls = routeNames
				.map((name, index) => {
					if (!name.toUpperCase().includes("ID") || skips.some(skip => name.toLowerCase().includes(skip)))
						return

					return { resourceName: name.toLowerCase(), resourceId: this.breadcrumbs[index] }
				})
				.filter(name => !!name && name.resourceId)
				.map(({ resourceName, resourceId }) => {
					let path = ""

					switch (true) {
						case resourceName.includes("school"):
							path = "organizations"
							break
						case resourceName.includes("project"):
							path = "projects"
							break
						case resourceName.includes("folder"):
							const previousRouteName =
								routeNames[
									routeNames.findIndex(routeName => routeName.toLowerCase() === resourceName) - 1
								]

							path = previousRouteName.includes("folder") ? "folders" : "projects"
							break
						case resourceName.includes("document"):
							path = "documents"
							break
						case resourceName.includes("subscription"):
							path = "subscriptions"
							break
						case resourceName.includes("variable"):
							path = "customfields"
							break
					}

					return {
						resourceName,
						resourceId,
						promise: axios(`${process.env.VUE_APP_API_URL}/api/${path}/${resourceId}`, {
							headers: {
								Authorization: `Bearer ${localStorage.getItem("JWT")}`
							}
						})
					}
				})

			axios
				.all(apiCalls.map(({ promise }) => promise))
				.then(responses => {
					this.names = responses.map(({ data }, index) => {
						const { resourceName, resourceId } = apiCalls[index] || {}
						let name = ""

						switch (true) {
							case resourceName.includes("school"):
								const customFieldValue =
									data.custom_field_values.find(
										({ custom_field: { name } }) => name === "denominazione scuola"
									) || {}
								name = customFieldValue.value || ""
								break
							case resourceName.includes("folder"):
								const previousRouteName =
									routeNames[
										routeNames.findIndex(routeName => routeName.toLowerCase() === resourceName) - 1
									]

								name = /*previousRouteName.includes("folder") ? data.description.String :*/ data.name

								break
							case resourceName.includes("document"):
								name = data.flowchart.title || ""
								break
							default:
								name = data.name
						}

						return { resourceId, name }
					})
				})
				.catch(errors => console.error(errors))
		},
		pathUpTo(index) {
			const slice = this.history.slice(0, index + 1)
			return `/${slice.join("/")}`
		},
		showName(name, index) {
			let array_route = this.$route.name.split(".")

			let { name: routeName } = this.names.find(({ resourceId }) => resourceId === name) || {}

			if (routeName) return `${this.$t(array_route[index])} "${routeName}"`
			else if (array_route[index] == name) return this.$t(name)
			else return this.$t(array_route[index]) + " " + name
		}
	}
}
</script>
